import { CONTEXT_TYPES } from './enums';

import type { ContextFilterOptions, FilterState, Filters, View } from './types';

const emptyFiltersByContext: Record<`${CONTEXT_TYPES}`, Filters> = {
  [CONTEXT_TYPES.ALTERNATIVES]: {},
  [CONTEXT_TYPES.BENCHMARK]: {},
  [CONTEXT_TYPES.EXPORT]: {},
  [CONTEXT_TYPES.FLOWMAP]: {},
  [CONTEXT_TYPES.GLOBAL]: {},
  [CONTEXT_TYPES.REPORTING]: {},
  [CONTEXT_TYPES.VIEW]: {},
  [CONTEXT_TYPES.DATASET]: {},
  [CONTEXT_TYPES.TEMP]: {},
};

const emptyViewsByContext: Record<`${CONTEXT_TYPES}`, View | null> = {
  [CONTEXT_TYPES.ALTERNATIVES]: null,
  [CONTEXT_TYPES.BENCHMARK]: null,
  [CONTEXT_TYPES.EXPORT]: null,
  [CONTEXT_TYPES.FLOWMAP]: null,
  [CONTEXT_TYPES.GLOBAL]: null,
  [CONTEXT_TYPES.REPORTING]: null,
  [CONTEXT_TYPES.VIEW]: null,
  [CONTEXT_TYPES.DATASET]: null,
  [CONTEXT_TYPES.TEMP]: null,
};

const emptyActiveSelectorsByContext: FilterState['activeSelectors'] = {
  [CONTEXT_TYPES.ALTERNATIVES]: {},
  [CONTEXT_TYPES.BENCHMARK]: {},
  [CONTEXT_TYPES.EXPORT]: {},
  [CONTEXT_TYPES.FLOWMAP]: {},
  [CONTEXT_TYPES.GLOBAL]: {},
  [CONTEXT_TYPES.REPORTING]: {},
  [CONTEXT_TYPES.VIEW]: {},
  [CONTEXT_TYPES.DATASET]: {},
  [CONTEXT_TYPES.TEMP]: {},
};

const emptyFilterOptionsByContext: Record<`${CONTEXT_TYPES}`, ContextFilterOptions> = {
  [CONTEXT_TYPES.ALTERNATIVES]: {},
  [CONTEXT_TYPES.BENCHMARK]: {},
  [CONTEXT_TYPES.EXPORT]: {},
  [CONTEXT_TYPES.FLOWMAP]: {},
  [CONTEXT_TYPES.GLOBAL]: {},
  [CONTEXT_TYPES.REPORTING]: {},
  [CONTEXT_TYPES.VIEW]: {},
  [CONTEXT_TYPES.DATASET]: {},
  [CONTEXT_TYPES.TEMP]: {},
};

export const filterInitialState: FilterState = {
  contextFilters: emptyFiltersByContext,
  contextViewsDefaults: emptyFiltersByContext,
  contextViews: emptyViewsByContext,
  activeSelectors: emptyActiveSelectorsByContext,
  contextFilterOptions: emptyFilterOptionsByContext,
};
